/** @jsx _j **/

/** @jsxFrag _f **/
var _require = require('astroturf'),
    _j = _require.jsx,
    _f = _require.F;

import sortBy from 'lodash/sortBy';
import { usePageData } from './DataProvider';
import SideNavigationHeader from './SideNavigationHeader';
import SideNavigationItem from './SideNavigationItem';
import SideNavigationLink from './SideNavigationLink';
import SideNavigationPanel from './SideNavigationPanel';
export { usePageData };

/** @public */
function SideNavigation(_ref) {
  var className = _ref.className;

  var _usePageData = usePageData(),
      pages = _usePageData.pages,
      api = _usePageData.api;

  return _j(SideNavigationPanel, {
    className: className
  }, _j("nav", null, _j("ul", null, pages.map(function (page) {
    return _j(SideNavigationItem, {
      key: page.path
    }, _j(SideNavigationLink, {
      to: page.path
    }, page.title));
  }), _j(SideNavigationItem, null, _j(SideNavigationHeader, null, "API"), _j("ul", {
    css: [require("./SideNavigation-CssProp1_ul.module.css"), []]
  }, sortBy(api, 'title').map(function (page) {
    return _j(SideNavigationItem, {
      key: page.title
    }, _j(SideNavigationLink, {
      to: page.path
    }, page.title));
  }))))));
}

SideNavigation.Panel = SideNavigationPanel;
SideNavigation.Header = SideNavigationHeader;
SideNavigation.Link = SideNavigationLink;
SideNavigation.Item = SideNavigationItem;
export default SideNavigation;